var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:_vm.footer === 'true' ? 'contact-form-1' : 'contact-form-2',on:{"click":_vm.openContactForm}},[_c('p',{staticClass:"title"},[_vm._v("CONTACT US")])])}
var staticRenderFns = []

export { render, staticRenderFns }